import axios,{ type AxiosInstance }  from "axios";
const baseURL = import.meta.env.VITE_BASE_URL
console.log("Base URL:", baseURL);

const api: AxiosInstance = axios.create({
  baseURL,
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    new Error(error);
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    new Error(error);
    return Promise.reject(error);
  }
);

export default api;
